import { gql } from '@apollo/client';

const CLINIC_NOTIFICATION_COUNT_QUERY = gql`
  query clinicNotificationCount($filter: ClinicNotificationFilterInput) {
    clinicNotificationCount(filter: $filter) {
      unseen
    }
  }
`;

export default CLINIC_NOTIFICATION_COUNT_QUERY;
